export default {
	title: "Jornadas",
	name: "Nome",
	description: "Descrição",
	order: "Ordem",
	createStage: "Nova Jornada",
	confirmDeleteMessage: "Tem certeza que deseja excluir a jornada \"{name}\"? Esta ação não pode ser desfeita.",
	confirmDeleteWithPeopleMessage: "A jornada \"{name}\" ainda possui médiuns vinculados. Deseja excluir mesmo assim? Os vínculos serão removidos junto.",
	hasAssociatedPeopleDetailed: "Existem {active} vínculo(s) ativo(s) e {inactive} inativo(s) nesta jornada. Desvincule-os antes de excluir.",
	viewActiveAssociated: "Ver ativos",
	associatedPeople: "Médiuns em: {name}",
	noAssociatedPeople: "Nenhum médium vinculado a esta jornada",
	confirmDeleteAssignment: "Tem certeza que deseja desvincular {person} da jornada \"{stage}\"?",
	createSuccess: "Jornada mediúnica criada com sucesso!",
	updateSuccess: "Jornada mediúnica atualizada com sucesso!",
	deleteSuccess: "Jornada mediúnica excluída com sucesso!",
	deleteError: "Erro ao excluir jornada mediúnica",
	empty: {
		title: "Nenhuma jornada mediúnica encontrada",
		description: "Cadastre as etapas de desenvolvimento espiritual do seu templo",
	},
	stats: {
		totalStages: "Estágios",
		totalPeople: "Pessoas",
		avgPerStage: "Média/Estágio",
	},
	category: {
		label: "Categoria",
		MEDIUNICA: "Mediúnica",
		RITUALISTICA: "Ritualística",
		FORMACAO: "Formação",
	},
	requiredStage: "Pré-requisito",
	requiredStageHint: "Marco que a pessoa precisa ter concluído antes",
};
